// extracted by mini-css-extract-plugin
export default {"footer":"ui_footer__8Toni","link":"ui_link__iW+Lo","active":"ui_active__rOOzF"};